import './shared';

import 'owl.carousel/dist/owl.carousel.min';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

import '../styles/home_index.css';

const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');

((
    ($) => {
        function owlCarousel() {
            $(".owl-main").owlCarousel({
                rtl: _isRtl,
                margin: 0,
                items: 1,
                nav: false,
                dots: true,
                lazyLoad: true,
                autoplay: true,
                loop: true,
                autoplayTimeout: 3000,
                animateIn: 'fadeIn',
                animateOut: 'fadeOut',
                autoplayHoverPause: false,
                onInitialized: function (event) {
                    const element = event.target;
                    $(element).closest('.loading').removeClass('loading');
                },
            });
        }

        owlCarousel();

        function item5Desc() {
            if ($(window).width() < 1200) {
                $('.item5').each(function (i, item) {
                    const _item = $(item);
                    const _desc = _item.find('.item5_desc');
                    if (!(_desc.html().trim() === '') && (_desc.html().length > 130)) {
                        _desc.html(_desc.html().substring(0, 130) + '..');
                    }
                    const _title = _item.find('.item5_title');
                    if (!(_title.html().trim() === '') && (_title.html().length > 15)) {
                        _title.html(_title.html().substring(0, 15) + '..');
                    }
                });
            }
        }

        function statDesign() {
            const homeStats = $('#js-home-stats');
            const item = homeStats.find('.js-stat-col');
            if ($(window).width() < 576) {
                homeStats.attr('class', '');
                homeStats.addClass('owl-stats owl-carousel owl-theme owl-flex owl-dots-style green');

                item.attr('class', 'js-stat-col');
                item.addClass('item');

                $(".owl-stats").owlCarousel({
                    rtl: _isRtl,
                    margin: 0,
                    dots: true,
                    loop: true,
                    items: 1,
                    autoplay: true,
                    lazyLoad: true,
                    slideTransition: 'ease',
                    autoplayTimeout: 3000,
                    autoplaySpeed: 1000,
                });
            }
        }

        $(window).on('resize', () => {
            item5Desc();
        });
        item5Desc();
        statDesign();
    }
)
(jQuery));

docReady(() => {
    let targets = $('.js-lazyload');

    if (targets.length) {
        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!$(entry.target).hasClass('activated')) {
                        if ($(entry.target).hasClass('latest-news-lazyload')) {
                            $(".owl-latest-news").owlCarousel({
                                rtl: _isRtl,
                                margin: 15,
                                dots: true,
                                loop: true,
                                autoplay: false,
                                lazyLoad: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    576: {
                                        items: 2,
                                    },
                                    768: {
                                        items: 3,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('home-projects-lazyload')) {
                            $(".owl-home-projects").owlCarousel({
                                rtl: _isRtl,
                                margin: 15,
                                dots: true,
                                loop: true,
                                lazyLoad: true,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    576: {
                                        items: 2,
                                    },
                                    768: {
                                        items: 3,
                                    },
                                    1200: {
                                        items: 4,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('courses-lazyload')) {
                            $(".owl-courses").owlCarousel({
                                rtl: _isRtl,
                                margin: 15,
                                dots: true,
                                loop: true,
                                autoplay: false,
                                lazyLoad: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    576: {
                                        items: 2,
                                    },
                                    768: {
                                        items: 3,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('partners-lazyload')) {
                            $(".owl-partners").owlCarousel({
                                rtl: _isRtl,
                                margin: 15,
                                dots: true,
                                loop: true,
                                autoplay: true,
                                lazyLoad: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    330: {
                                        items: 2,
                                    },
                                    576: {
                                        items: 3,
                                    },
                                    768: {
                                        items: 5,
                                    },
                                    992: {
                                        items: 6,
                                    }
                                }
                            });
                        }
                    }
                }
            });
        }, options);

        targets.each(target => {
            observer.observe(targets[target]);
        });
    }
});